import { useEffect as d } from "react";

function m(i, e, n, o) {
  d(function () {
    if (!e) return;

    var t = function t(s) {
      var r = s.target;
      if (!r) return;
      var u = Array.from(document.querySelectorAll(e));
      if (u.length < 1) throw new Error("querySelectorAll did not find a container for the useOnClickOutside hook");
      n && !r.closest(n) || u.find(function (c) {
        return c.contains(s.target);
      }) && o && !r.closest(o) || i(s);
    };

    return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), function () {
      document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
    };
  }, [i, e, o, n]);
}

export { m as useOnClickOutside };